(function () {
  'use strict';

  var REQUEST_TIMEOUT_MS = 15000;

  function text(value) {
    return typeof value === 'string' ? value : '';
  }

  function apiOrigin(value) {
    try {
      var url = new URL(text(value).trim());
      return url.protocol === 'https:' && !url.username && !url.password
        ? url.origin
        : '';
    } catch (_error) {
      return '';
    }
  }

  function trimmedField(form, name) {
    var field = form.elements.namedItem(name);
    return field && typeof field.value === 'string' ? field.value.trim() : '';
  }

  function setBusy(form, busy) {
    var button = form.querySelector('[data-submit-button]');
    var spinner = form.querySelector('[data-loading-spinner]');
    var label = form.querySelector('[data-button-label]');
    if (button) button.disabled = busy;
    if (spinner) spinner.hidden = !busy;
    if (label) label.textContent = busy ? 'Submitting…' : 'Submit';
    form.setAttribute('aria-busy', busy ? 'true' : 'false');
  }

  function friendlyError(error) {
    if (error && error.name === 'AbortError') {
      return 'This is taking longer than expected. Please try again.';
    }
    if (error && error.status === 429) {
      return 'Too many requests have been sent. Please wait a moment and try again.';
    }
    if (error && error.status === 400) {
      return 'Please check the information entered and try again.';
    }
    return 'We could not connect to DS Store right now. Please try again shortly.';
  }

  function apiRequest(url, options) {
    var controller = new AbortController();
    var timer = window.setTimeout(function () {
      controller.abort();
    }, REQUEST_TIMEOUT_MS);
    var requestOptions = Object.assign({}, options || {}, {
      signal: controller.signal,
      headers: Object.assign(
        { Accept: 'application/json' },
        options && options.headers ? options.headers : {}
      )
    });

    return fetch(url, requestOptions)
      .then(function (response) {
        return response.json().catch(function () {
          return null;
        }).then(function (body) {
          if (!response.ok || !body || body.success !== true) {
            var error = new Error('Request failed');
            error.status = response.status;
            throw error;
          }
          return body.data;
        });
      })
      .finally(function () {
        window.clearTimeout(timer);
      });
  }

  function postJson(url, body) {
    return apiRequest(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body)
    });
  }

  function showAskMessage(container, answerable, answer) {
    container.replaceChildren();
    container.classList.remove('product-faq__message--error');
    if (answerable) {
      var heading = document.createElement('strong');
      heading.textContent = 'LARA Answer';
      var answerText = document.createElement('span');
      answerText.textContent = text(answer);
      var review = document.createElement('span');
      review.textContent = 'Your question has also been submitted for review.';
      container.append(heading, answerText, review);
    } else {
      var submitted = document.createElement('span');
      submitted.textContent = text(answer) ||
        'Thank you for your question. It has been forwarded to the DS Store team for review.';
      container.append(submitted);
    }
    container.hidden = false;
  }

  function showError(container, message) {
    container.replaceChildren();
    container.classList.add('product-faq__message--error');
    container.textContent = message;
    container.hidden = false;
  }

  function payloadFromForm(form, primaryName) {
    var payload = {};
    payload[primaryName] = trimmedField(form, primaryName);
    var name = trimmedField(form, 'visitorName');
    var email = trimmedField(form, 'visitorEmail');
    if (name) payload.visitorName = name;
    if (email) payload.visitorEmail = email;
    return payload;
  }

  function communityField(labelText, name, type, maxLength, required) {
    var wrapper = document.createElement('div');
    wrapper.className = 'product-faq__field';
    var label = document.createElement('label');
    var input = document.createElement(type === 'textarea' ? 'textarea' : 'input');
    var id = 'Community-' + name + '-' + Math.random().toString(36).slice(2);
    label.htmlFor = id;
    label.textContent = labelText;
    input.id = id;
    input.name = name;
    input.maxLength = maxLength;
    input.required = Boolean(required);
    if (type !== 'textarea') {
      input.type = type;
      if (type === 'email') input.autocomplete = 'email';
      if (name === 'visitorName') input.autocomplete = 'name';
    } else {
      input.rows = 2;
      input.minLength = 3;
    }
    wrapper.append(label, input);
    return wrapper;
  }

  function formatDate(value) {
    var date = new Date(value);
    return Number.isNaN(date.getTime())
      ? ''
      : new Intl.DateTimeFormat('en-GB', { dateStyle: 'medium' }).format(date);
  }

  function renderCommunityItem(item, apiBase) {
    var article = document.createElement('article');
    article.className = 'product-faq__community-item';
    var question = document.createElement('p');
    question.className = 'product-faq__community-question';
    question.textContent = text(item.question);
    var meta = document.createElement('p');
    meta.className = 'product-faq__community-meta';
    var answerCount = Number.isInteger(item.answerCount) ? item.answerCount : 0;
    meta.textContent =
      [text(item.contributorName || 'Community Member'), formatDate(item.submittedAt), text(item.threadStatus || 'open'), text(item.publicStatus || 'Awaiting Answers'), answerCount + (answerCount === 1 ? ' approved reply' : ' approved replies')]
        .filter(Boolean)
        .join(' · ');

    var approvedAnswers = document.createElement('div');
    approvedAnswers.className = 'product-faq__community-answers';
    (Array.isArray(item.answers) ? item.answers : []).forEach(function (approved) {
      var answerCard = document.createElement('div');
      answerCard.className = 'product-faq__community-answer';
      var answerText = document.createElement('p');
      answerText.textContent = text(approved.answer);
      answerCard.append(answerText);
      var contributor = document.createElement('small');
      contributor.textContent = text(approved.contributorName || 'Community Member');
      answerCard.append(contributor);
      if (approved.isSelected === true) {
        var selected = document.createElement('span');
        selected.className = 'product-faq__verified-answer';
        selected.textContent = 'Selected Answer';
        answerCard.append(selected);
      }
      if (approved.isOfficial === true) {
        var verified = document.createElement('span');
        verified.className = 'product-faq__verified-answer';
        verified.textContent = 'DS Store verified';
        answerCard.append(verified);
      }
      approvedAnswers.append(answerCard);
    });

    var form = document.createElement('form');
    form.className = 'product-faq__community-form';
    form.noValidate = true;
    form.append(
      communityField('Your Answer', 'answer', 'textarea', 1200, true),
      communityField('Your name (optional)', 'visitorName', 'text', 100, false),
      communityField('Email (optional)', 'visitorEmail', 'email', 254, false)
    );
    var actions = document.createElement('div');
    actions.className = 'product-faq__actions';
    var button = document.createElement('button');
    button.type = 'submit';
    button.className = 'product-faq__button';
    button.setAttribute('data-submit-button', '');
    var label = document.createElement('span');
    label.setAttribute('data-button-label', '');
    label.textContent = 'Submit';
    var spinner = document.createElement('span');
    spinner.className = 'product-faq__spinner';
    spinner.setAttribute('data-loading-spinner', '');
    spinner.setAttribute('aria-hidden', 'true');
    spinner.hidden = true;
    actions.append(button);
    button.append(label, spinner);
    form.append(actions);
    if (text(item.threadStatus) !== 'open') {
      form.hidden = true;
      var closedMessage = document.createElement('p');
      closedMessage.className = 'product-faq__community-meta';
      closedMessage.textContent =
        item.threadStatus === 'locked'
          ? 'This discussion is locked to new replies.'
          : 'This discussion is closed to new replies.';
      approvedAnswers.append(closedMessage);
    }
    var message = document.createElement('div');
    message.className = 'product-faq__message';
    message.setAttribute('role', 'status');
    message.setAttribute('aria-live', 'polite');
    message.hidden = true;

    var submitting = false;
    form.addEventListener('submit', function (event) {
      event.preventDefault();
      event.stopPropagation();
      if (submitting) return;
      if (!form.reportValidity()) return;
      var payload = payloadFromForm(form, 'answer');
      if (payload.answer.length < 3) return;
      submitting = true;
      setBusy(form, true);
      message.hidden = true;
      postJson(
        apiBase + '/api/v1/public/questions/' + encodeURIComponent(text(item.questionId)) + '/answers',
        payload
      ).then(function () {
        message.classList.remove('product-faq__message--error');
        message.textContent =
          'Thank you. Your answer has been submitted for DS Store review and will not appear publicly until approved.';
        message.hidden = false;
        form.reset();
      }).catch(function (error) {
        showError(message, friendlyError(error));
      }).finally(function () {
        submitting = false;
        setBusy(form, false);
      });
    });

    article.append(question, meta, approvedAnswers, form, message);
    return article;
  }

  function initialiseAssistantBubble(section) {
    var bubble = section.querySelector('[data-assistant-bubble]');
    if (!bubble || section.dataset.assistantBubbleReady === 'true') return;

    var messages = [
      'Ask LARA anything about this product!',
      'LARA answers using verified DS Store information.',
      'Need help deciding? I\u2019m here to help.',
      'If LARA isn\u2019t sure, your question goes to our team.'
    ];
    var currentIndex = 0;
    var transitionTimer = null;
    var rotationTimer = null;
    var reduceMotion = window.matchMedia &&
      window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    section.dataset.assistantBubbleReady = 'true';
    bubble.textContent = messages[0];

    function showNextMessage() {
      if (transitionTimer !== null) return;
      bubble.classList.add('is-changing');
      transitionTimer = window.setTimeout(function () {
        currentIndex = (currentIndex + 1) % messages.length;
        bubble.textContent = messages[currentIndex];
        bubble.classList.remove('is-changing');
        transitionTimer = null;
      }, 180);
    }

    function startRotation() {
      if (reduceMotion || messages.length < 2 || rotationTimer !== null ||
          document.hidden) return;
      rotationTimer = window.setInterval(showNextMessage, 4500);
    }

    function stopRotation() {
      if (rotationTimer !== null) {
        window.clearInterval(rotationTimer);
        rotationTimer = null;
      }
    }

    function handleVisibilityChange() {
      if (document.hidden) stopRotation();
      else startRotation();
    }

    function cleanup() {
      stopRotation();
      if (transitionTimer !== null) {
        window.clearTimeout(transitionTimer);
        transitionTimer = null;
      }
      document.removeEventListener('visibilitychange', handleVisibilityChange);
      delete section.dataset.assistantBubbleReady;
      delete section._faqAssistantCleanup;
    }

    section._faqAssistantCleanup = cleanup;
    document.addEventListener('visibilitychange', handleVisibilityChange);
    startRotation();
  }

  function initialise(section) {
    if (!section) return;
    initialiseAssistantBubble(section);

    var handle = text(section.dataset.productHandle).trim();
    var apiBase = apiOrigin(section.dataset.apiBase);
    var askForm = section.querySelector('[data-ask-form]');
    var askMessage = section.querySelector('[data-ask-message]');
    var communitySection = section.querySelector('[data-community-section]');
    var communityStatus = section.querySelector('[data-community-status]');
    var communityList = section.querySelector('[data-community-list]');

    function revealCommunity() {
      if (!communitySection) return;
      communitySection.hidden = false;
      if (window.requestAnimationFrame) {
        window.requestAnimationFrame(function () {
          communitySection.classList.add('is-visible');
        });
      } else {
        communitySection.classList.add('is-visible');
      }
    }

    if (
      askForm &&
      askMessage &&
      askForm.dataset.askQuestionReady !== 'true'
    ) {
      var asking = false;

      askForm.addEventListener('submit', function (event) {
        event.preventDefault();
        event.stopPropagation();
        if (asking) return;

        if (!askForm.reportValidity()) {
          return;
        }

        var payload = payloadFromForm(askForm, 'question');
        if (payload.question.length < 3) {
          showError(askMessage, 'Please enter a question before submitting.');
          return;
        }
        if (!handle || !apiBase) {
          showError(
            askMessage,
            'The product assistant is temporarily unavailable. Please try again shortly.'
          );
          return;
        }

        asking = true;
        setBusy(askForm, true);
        askMessage.hidden = true;
        postJson(
          apiBase + '/api/v1/public/products/' + encodeURIComponent(handle) + '/questions/ask',
          payload
        ).then(function (data) {
          showAskMessage(askMessage, data.answerable === true, data.answer);
          askForm.reset();
        }).catch(function (error) {
          showError(askMessage, friendlyError(error));
        }).finally(function () {
          asking = false;
          setBusy(askForm, false);
        });
      });

      var questionField = askForm.querySelector('[name="question"]');
      if (questionField) {
        questionField.addEventListener('keydown', function (event) {
          if (
            event.key === 'Enter' &&
            !event.shiftKey &&
            !event.isComposing
          ) {
            event.preventDefault();
            askForm.requestSubmit();
          }
        });
      }

      askForm.dataset.askQuestionReady = 'true';
      section.dataset.questionUiReady = 'true';
    }

    if (
      communityStatus &&
      communityList &&
      section.dataset.communityQuestionsReady !== 'true' &&
      handle &&
      apiBase
    ) {
      section.dataset.communityQuestionsReady = 'true';
      window.setTimeout(function () {
        apiRequest(
          apiBase + '/api/v1/public/products/' + encodeURIComponent(handle) + '/questions/unanswered'
        ).then(function (data) {
          var questions = Array.isArray(data.questions) ? data.questions : [];
          communityList.replaceChildren();
          if (questions.length === 0) {
            communityStatus.hidden = false;
            communityStatus.textContent =
              'Questions that could not be answered automatically will appear here after moderation. Community members can contribute answers, and all published answers are reviewed and approved by the DS Store team.';
            revealCommunity();
            return;
          }
          communityStatus.hidden = true;
          questions.forEach(function (item) {
            communityList.append(renderCommunityItem(item, apiBase));
          });
          revealCommunity();
        }).catch(function () {
          communityStatus.hidden = false;
          communityStatus.textContent =
            'Community questions are temporarily unavailable. Please try again later.';
          revealCommunity();
        });
      }, 0);
    }
  }

  function initialiseAll(root) {
    var scope = root || document;

    if (
      scope.nodeType === 1 &&
      typeof scope.matches === 'function' &&
      scope.matches('[data-product-faq]')
    ) {
      initialise(scope);
    }

    if (typeof scope.querySelectorAll === 'function') {
      scope.querySelectorAll('[data-product-faq]').forEach(initialise);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initialiseAll(document);
    }, { once: true });
  } else {
    initialiseAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initialiseAll(event.target);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    var scope = event.target;
    if (
      scope &&
      scope.nodeType === 1 &&
      typeof scope.matches === 'function' &&
      scope.matches('[data-product-faq]')
    ) {
      if (typeof scope._faqAssistantCleanup === 'function') {
        scope._faqAssistantCleanup();
      }
    }
    if (scope && typeof scope.querySelectorAll === 'function') {
      scope.querySelectorAll('[data-product-faq]').forEach(function (section) {
        if (typeof section._faqAssistantCleanup === 'function') {
          section._faqAssistantCleanup();
        }
      });
    }
  });
})();
